import React, { useEffect } from 'react';
import Layout from '../../Layout/Layout';
import { Container, Row, Col } from 'reactstrap';
import TitleBar from '../../Layout/TitleBar';
import {
  CookbookMealListEdge,
  withLoading,
  callNativeMobileApp,
} from '@front-activerse/common-components';
import CookbookMealItem from '../components/CookbookMealItem';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { useOutletContext } from 'react-router-dom';

interface ICookbookTagMealsContainer {
  tagName: string;
  tagType: string;
  tagId: string;
  meals: CookbookMealListEdge[];
  addToFavorites: (mealId: number) => Promise<unknown>;
  removeFromFavorites: (mealId: number) => Promise<unknown>;
}

export const CookbookTagMealsContainer: React.FC<ICookbookTagMealsContainer> = ({
  tagName,
  tagType,
  tagId,
  meals,
  addToFavorites,
  removeFromFavorites,
}) => {
  const { trackFirebaseEvent } = useOutletContext<{
    trackFirebaseEvent: (eventName: string, eventPayload: object) => void;
  }>();

  useEffect(() => {
    if (tagName) {
      callNativeMobileApp({
        action: 'title_changed',
        payload: {
          title: tagName,
        },
      });
    }

    trackFirebaseEvent('screen_view', {
      firebase_screen: 'Cookbook_tag_meals',
      tag_type: tagType,
      tag_id: tagId,
      meals_tab: 'cookbook',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagType, tagId]);

  return (
    <Layout>
      <TitleBar level={1}>{tagName}</TitleBar>
      <div className="page-template-cookbook full-height3">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="cookbook-category">
                  <Row className="cookbook-meals">
                    {meals.map(({ node }) => (
                      <CookbookMealItem
                        key={node.id}
                        {...node}
                        addToFavorites={addToFavorites}
                        removeFromFavorites={removeFromFavorites}
                        orientation="horizontal"
                      />
                    ))}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

const Placeholder = () => <UniversalPlaceholder titleBar="" />;

export default withLoading(CookbookTagMealsContainer, Placeholder);
